import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { parseLocationRegistryOptions } from 'features/locationRegistry/locationRegistryMappers'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { ITaskTemplateComponent, ITaskTemplateState } from 'types/task-templates.interface'

const RenderComponentInput = ({ handleChange, value, labelText, name }) => {
  return <Input type='number' labelText={labelText} name={name} value={value} onChange={handleChange} placeholder='Enter value' />
}

const RenderCalendarInput = ({ handleChange, value, labelText, name }) => {
  return <CalendarInput
    labelText={labelText}
    name={name}
    defaultValue={value}
    onChange={handleChange}
    placeholder='Select date'
  />
}

const RenderSelectInput = ({ handleChange, value, labelText, name, options = typeOfMaterialsOptions }) => {
  return <HonestSelectInput options={options} onChange={handleChange} defaultValue={value} labelText={labelText} name={name} placeholder='Select value' />
}

const RenderAsyncSelectInput = ({ handleChange, value, name = 'location', labelText = 'Location' }) => {
  return <HonestSelectAsyncInput
    nomarg
    link='locations'
    placeholder='Search locations'
    name={name}
    labelText={labelText}
    defaultValue={value}
    onChange={handleChange}
    parserFunction={parseLocationRegistryOptions}
    required
  />
}

const typeOfMaterialsOptions = [
  { label: 'Soil', value: 1 },
  { label: 'Sand', value: 2 },
  { label: 'Yellow Stone', value: 3 },
  { label: 'Other', value: 4 },
]

// input types
// 1 - text
// 2 - number
// 3 - date
// 4 - select
// 5 - async select

export const components: ITaskTemplateComponent[] = [
  { name: 'Area', component: 1, componentType: 1, inputType: 2, renderInput: ({ handleChange, value, name, labelText }) => <RenderComponentInput name={name || 'area'} labelText={labelText || 'Area'} handleChange={handleChange} value={value} /> },
  { name: 'Size', component: 2, componentType: 1 },
  { name: 'Machinery', component: 3, componentType: 1 },
  { name: 'Operators', component: 4, componentType: 1 },
  { name: 'Stuff', component: 5, componentType: 1, inputType: 2, renderInput: ({ handleChange, value, name, labelText }) => <RenderComponentInput labelText={labelText || 'Stuff'} name={name || 'stuff'} handleChange={handleChange} value={value} /> },
  { name: 'Time', component: 6, componentType: 1 },
  { name: 'Location', component: 7, link: 'locations/', parserFunction: (data: any) => ({ value: data.id, label: data.name }), componentType: 1, inputType: 5, renderInput: ({ handleChange, value, name, labelText }) => <RenderAsyncSelectInput handleChange={handleChange} value={value} name={name || 'location'} labelText={labelText || 'Location'} /> },
  { name: 'Distance', component: 8, componentType: 1 },
  { name: 'Pickup', component: 9, componentType: 1 },
  { name: 'Delivery', component: 10, componentType: 1 },
  { name: 'Item', component: 11, componentType: 1 },
  { name: 'Cargo', component: 12, componentType: 1 },
  { name: 'Amount', component: 13, componentType: 1 },
  { name: 'Volume', component: 14, componentType: 1, inputType: 2, renderInput: ({ handleChange, value, name, labelText }) => <RenderComponentInput labelText={labelText || 'Volume'} name={name || 'volume'} handleChange={handleChange} value={value} /> },
  { name: 'Capacity', component: 15, componentType: 1 },
  { name: 'Height', component: 16, componentType: 1 },
  { name: 'Speed', component: 17, componentType: 1 },
  { name: 'Width', component: 18, componentType: 1 },
  { name: 'Length', component: 19, componentType: 1, inputType: 2, renderInput: ({ handleChange, value, name, labelText }) => <RenderComponentInput labelText={labelText || 'Length'} name={name || 'length'} handleChange={handleChange} value={value} /> },
  { name: 'Depth', component: 20, componentType: 1, inputType: 2, renderInput: ({ handleChange, value, name, labelText }) => <RenderComponentInput labelText={labelText || 'Depth'} name={name || 'depth'} handleChange={handleChange} value={value} /> },
  { name: 'Weight', component: 21, componentType: 1 },
  { name: 'Type', component: 22, componentType: 1 },
  { name: 'Coordinates', component: 23, componentType: 1 },
  { name: 'Quantity', component: 24, componentType: 1, inputType: 2, renderInput: ({ handleChange, value, name, labelText }) => <RenderComponentInput labelText={labelText || 'Quantity'} name={name || 'quantity'} handleChange={handleChange} value={value} /> },
  { name: 'Duration', component: 25, componentType: 1, inputType: 2, renderInput: ({ handleChange, value, name, labelText }) => <RenderComponentInput labelText={labelText || 'Duration'} name={name || 'duration'} handleChange={handleChange} value={value} /> },
  { name: 'Date', component: 26, componentType: 1, inputType: 3, renderInput: ({ handleChange, value, name, labelText }) => <RenderCalendarInput name={name || 'date'} labelText={labelText || 'Date'} handleChange={handleChange} value={value} /> },
  { name: 'TypeOfMaterial', component: 27, componentType: 1, options: typeOfMaterialsOptions, inputType: 4, renderInput: ({ handleChange, value, name, labelText }) => <RenderSelectInput labelText={labelText || 'Type of Material'} name={name || 'typeOfMaterial'} handleChange={handleChange} value={value} /> },
]

export const taskComponentTypes: ISelectValue[] = [
  { label: 'Input', value: 1 },
  { label: 'Calculated', value: 2 },
  { label: 'Display', value: 3 },
]


// export const workerComponents:ITaskWComponent[] = [
//   { name: 'Number', component: 1 },
//   { name: 'Text', component: 2 },
//   { name: 'List of numbers', component: 3 },
// ]

export const taskTemplatesInitialState: ITaskTemplateState = {
  name: '',
  logic: [],
  operationTypeId: null,
  operationTypeParameterValues: [],
  components: [],
  selectedOperation: null,
  allowedRoles: [],
  fallBackRoles: [],
  workerComponents: [],
  image: null,
  toolTypeComponents: [],
  shouldUseLocationTracking: false,
  imageRaw: null,
  workUnitAmounts: [],

  requiredCapability: null,

  operation: null,
  operationParameterValues: [],
}

export const criteria: ISelectValue[] = [
  { label: 'Cheapest', value: 1 },
  { label: 'Soonest', value: 2 },
  { label: 'By Priority', value: 3 },
  { label: 'By Rating', value: 4 },
]
